import { render, staticRenderFns } from "./SuccessBox.vue?vue&type=template&id=6dc6917e&"
import script from "./SuccessBox.vue?vue&type=script&lang=js&"
export * from "./SuccessBox.vue?vue&type=script&lang=js&"
import style0 from "./SuccessBox.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports